<script lang="tsx" setup>
import {ref, watch} from 'vue';
import FileUploadOss from '#/components/file/uploadOss.vue';
import { useVbenModal } from '@vben/common-ui';
import {ElMessage} from "element-plus";
import {uploadTkShippingLabelApi} from "#/api/core";
const orderId = ref('');
const expressLabelUrl = ref('');
let fileList = ref([]);
let loading = ref(false);
const [Modal, modalApi] = useVbenModal({
  title: '上传面单',
  class: 'w-700px min-h-500px',
  showConfirmButton: true,
  cancelText: '关闭',
  onOpenChange(isOpen) {
    if (isOpen) {
      const data = modalApi.getData();
      orderId.value = data.orderId;
      modalApi.setData({ refresh: false });
      if(data.expressLabelUrl){
        expressLabelUrl.value = data.expressLabelUrl;
        fileList.value = [
          {name:'面单.pdf',url:data.expressLabelUrl,media_url:data.expressLabelUrl,media_type:4}
        ]
      }
    }else{
      close()
    }
  },
  onConfirm() {
    if(loading.value){
      return;
    }
    if(!expressLabelUrl.value){
      ElMessage.warning('请上传面单');
      return
    }
    let params = {
      orderId:orderId.value,
      shippingLabelOssPath:expressLabelUrl.value
    }
    loading.value = true
    uploadTkShippingLabelApi(params).then((res)=>{
      loading.value = false
      ElMessage.success('保存成功！')
      modalApi.setData({ refresh: true }).close();
    },()=>{
      loading.value = false
    })
  }
});

function close(){
  orderId.value = '';
  expressLabelUrl.value = '';
  fileList.value = []
}

watch(() => fileList.value, (nv:any) => {
  if(nv && nv.length){
    expressLabelUrl.value = nv[0].submit_key || nv[0].media_url
  }else{
    expressLabelUrl.value = ''
  }
},{deep:true,immediate:true})
</script>
<template>
  <Modal>
    <div class="flex min-h-[500px] items-center justify-center" v-loading="loading">
      <FileUploadOss v-model:files="fileList"
                    :limit="1"
                    multiple
                    accept="application/pdf">
        <template #tip>
          <p style="margin-top: 10px">上传经营平台中购买的官方面单.PDF文件</p>
        </template>
      </FileUploadOss>
    </div>
  </Modal>
</template>
<style lang="scss">
.w-700px{
  width: 700px;
}
</style>
